import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../../common/breadcrumbs";
import { QuestionDetails } from "../../../services/question.services";
import { questionType } from "../../../../../utils/Constants";

const QuestionView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Question"),
      url: "/admin/cms/question/list/1",
    },
    { title: t("View"), url: "" },
  ];


  useEffect(() => {
    QuestionDetails(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Question title")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.question_title
                              ? showdefault.question_title
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("Question type")}</th>
                          <td>
                            {showdefault && showdefault.question_type
                              ? questionType.find(type => type.value === showdefault.question_type)?.name
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Option")}</th>
                          <td>
                            {showdefault && showdefault.option && showdefault.option.length > 0 ? (
                              <ul>
                                {showdefault.option.map((opt, index) => (
                                  <li key={index}>{opt.option_value}</li>
                                ))}
                              </ul>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
            <div className="ml-4 back-button mx-0">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/cms/question/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionView;
